import { DEFAULT_VIDEO_DURATION, DEFAULT_VIDEO_RATIO } from "~/common/constants"
import type { VideoTemplate } from "./types"

export const DEFAULT_TEMPLATE_RANK = 1

export const isPositiveTemplateRank = (rank: unknown): rank is number =>
  typeof rank === "number" && Number.isFinite(rank) && rank > 0

export const createVideoTemplate = (
  values: Partial<VideoTemplate> = {},
): VideoTemplate => ({
  templateId: "",
  rank: DEFAULT_TEMPLATE_RANK,
  title: "",
  categories: [],
  keywords: [],
  videoUrl: "",
  videoCover: "",
  downloadUrl: "",
  model: null,
  resolution: null,
  duration: DEFAULT_VIDEO_DURATION,
  ratio: null,
  sameStyleAvailable: false,
  sameStyleUnavailableReason: "",
  prompt: "",
  fields: [],
  referenceImages: [],
  referenceAudios: [],
  motionReference: null,
  ...values,
})

export const getTemplateRatio = (template: VideoTemplate): API.VideoRatio =>
  template.ratio ?? DEFAULT_VIDEO_RATIO

export const isTemplateAvailable = (template: VideoTemplate): boolean =>
  template.sameStyleAvailable &&
  Boolean(template.prompt.trim()) &&
  template.referenceImages.length > 0
